// @flow
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

export const Svg = styled.svg`
  border-radius: ${({ circular }) => (circular ? "50%" : "2px")};
  border: ${({ circular }) =>
    circular ? `1px solid ${buildColor("grey", "L2")}` : "none"};
  box-sizing: border-box;
`;
